import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function StateOfBrand() {
  return (
    <div className="min-h-screen bg-[#F7F7F8] text-[#0A0B0D]" data-testid="state-page">
      <nav className="border-b border-[#E5E5EA] bg-white">
        <div className="max-w-[1320px] mx-auto h-14 px-5 lg:px-8 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 bg-[#0A0B0D] text-white font-display font-bold text-[13px] flex items-center justify-center">S</div>
            <div className="font-display font-bold text-[14px] tracking-tight">SPAN</div>
            <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-[#475467] hidden sm:block">· State of Brand Counterfeiting</div>
          </Link>
          <Link to="/" className="text-[12px] hover:text-[#0A0B0D]/70">← Home</Link>
        </div>
      </nav>

      <section className="py-16 lg:py-24 bg-[#0A0B0D] text-white border-b border-[#0A0B0D]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-8">
          <div className="label-eyebrow mb-5" style={{color: "rgba(255,255,255,0.6)"}}>STATE OF BRAND COUNTERFEITING · 2026 EDITION</div>
          <h1 className="font-display font-bold text-[48px] sm:text-[80px] leading-[0.92] tracking-[-0.03em]">
            Where they hide.<br/>What they steal.<br/>How fast we close.
          </h1>
          <p className="text-[18px] mt-8 max-w-[680px] leading-[1.55] text-white/80">
            SPAN's first annual report — drawn entirely from anonymized live customer data across
            India, Bangladesh, UAE, Singapore and Nepal. Free to read, no email gate.
          </p>
          <div className="flex flex-wrap gap-3 mt-9">
            <a href="#stats" className="span-btn" style={{background: "#fff", color: "#000", borderColor: "#fff"}}>Read the data <ArrowRight size={13} /></a>
            <a href="mailto:pankaj@span.com?subject=Press%20copy%20of%20State%20of%20Brand%202026" className="span-btn span-btn-ghost" style={{borderColor: "#fff", color: "#fff"}}>Press copy</a>
          </div>
        </div>
      </section>

      <section id="stats" className="py-16 border-b border-[#E5E5EA]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-8">
          <div className="label-eyebrow mb-4">HEADLINE NUMBERS · ALL-TIME · ANONYMIZED</div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-6">
            {[
              {n: "147",     l: "active cases"},
              {n: "₹38.4 Cr", l: "exposure mitigated"},
              {n: "73%",     l: "of clusters in tier-2 cities"},
              {n: "9 days",  l: "median resolution"},
            ].map((s) => (
              <div key={s.l}>
                <div className="font-display font-bold text-[44px] lg:text-[56px] leading-none tracking-tight tnum">{s.n}</div>
                <div className="label-eyebrow mt-3">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 border-b border-[#E5E5EA]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-8">
          <div className="label-eyebrow mb-3">KEY FINDINGS</div>
          <h2 className="font-display font-bold text-[36px] tracking-tight">The shape of counterfeit operations in 2026.</h2>
          <div className="grid lg:grid-cols-3 gap-6 mt-10">
            {[
              {n: "01", t: "Tier-2 cities dominate",
               d: "73% of counterfeit clusters mapped in 2026 sit outside India's top-8 metros. Lucknow, Patna, Ranchi and Indore lead. Enforcement still lives in metros."},
              {n: "02", t: "Telegram replaced WhatsApp",
               d: "63% of network-type signals now route via Telegram channels. Bots auto-broker between source and reseller — faster than the old WhatsApp model."},
              {n: "03", t: "Pharma is the hardest hit",
               d: "Pharma category has 2.4× more critical-severity signals than next-highest (FMCG). Patient-safety implications make it the #1 priority for joint enforcement."},
              {n: "04", t: "Price anomalies are the leading indicator",
               d: "78% of cluster discoveries start with a pricing anomaly signal. >35% below MRP across 5+ sellers is the threshold that justifies a field dispatch."},
              {n: "05", t: "Cross-border BD–IN is rising",
               d: "Border interdictions at Petrapole and Benapole crossings up 47% YoY. Counterfeit pharma flows IN→BD, fake auto parts BD→IN."},
              {n: "06", t: "Chain of custody is the difference",
               d: "In SPAN-handled cases, 92% of evidence packets were court-admitted on first hearing. Industry baseline: 47%."},
            ].map((f) => (
              <div key={f.n} className="border border-[#E5E5EA] bg-white p-6">
                <div className="font-mono text-[10px] text-[#475467]">{f.n}</div>
                <div className="font-display font-bold text-[17px] mt-4">{f.t}</div>
                <div className="text-[13px] text-[#475467] mt-2 leading-[1.55]">{f.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[800px] mx-auto px-5 text-center">
          <div className="label-eyebrow mb-3">METHODOLOGY</div>
          <h2 className="font-display font-bold text-[32px] tracking-tight">Built on real signals, never speculation.</h2>
          <p className="text-[14px] text-[#475467] mt-3 leading-[1.6]">
            Every figure in this report is derived from live SPAN customer telemetry — anonymized,
            aggregated, and category-coded. Individual brand names, sellers, and identifiable counterfeiters
            are excluded. We re-publish the data quarterly for academic and policy research access.
          </p>
          <div className="flex flex-wrap gap-3 justify-center mt-7">
            <a href="mailto:pankaj@span.com?subject=Research%20data%20access" className="span-btn">Request research access <ArrowRight size={13} /></a>
            <Link to="/counterfeit-registry" className="span-btn span-btn-ghost">See the live registry</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
